import Privacy from './index.vue'
export default Privacy